/**
 * Planes y límites. El cliente los aplica para dar respuesta inmediata;
 * el servidor los vuelve a comprobar en cada operación (FR-BIZ-01).
 */
export type PlanId = 'free' | 'premium';

export interface PlanLimits {
  activeHabits: number;
  remindersPerHabit: number;
  advancedStats: boolean;
  serverBackups: boolean;
}

export const PLAN_LIMITS: Record<PlanId, PlanLimits> = {
  free: { activeHabits: 7, remindersPerHabit: 1, advancedStats: false, serverBackups: false },
  premium: { activeHabits: 500, remindersPerHabit: 5, advancedStats: true, serverBackups: true },
};

interface HabitLike {
  kind?: unknown;
  archivedAt?: unknown;
  deletedAt?: unknown;
  completedAt?: unknown;
}

/** Un hábito cuenta para el límite si no está archivado ni eliminado. Las tareas completadas no cuentan. */
export function isActiveHabit(h: HabitLike): boolean {
  if (h.deletedAt || h.archivedAt) return false;
  if (h.kind === 'task' && h.completedAt) return false;
  return true;
}

export function countActiveHabits(habits: Iterable<HabitLike>): number {
  let n = 0;
  for (const h of habits) if (isActiveHabit(h)) n++;
  return n;
}
